import {
  getDecodedNetworkId,
  getDecodedUserId,
  getTelemetryClientConfig,
  getTelemetryHostingConfig,
} from '@ms/yammer-telemetry-store';

import type { ApplicationContextInput } from '../events';

type GetApplicationContextInput = () => ApplicationContextInput;
export const getApplicationContextInput: GetApplicationContextInput = () => {
  const userId = getDecodedUserId();
  const networkId = getDecodedNetworkId();
  const clientConfig = getTelemetryClientConfig();
  const hostingConfig = getTelemetryHostingConfig();

  if (!clientConfig || !hostingConfig) {
    return {
      ClientId: '<not configured>',
      first_party_client: '<not configured>',
      client_load_id: '<not configured>',
      client_load_time: '<not configured>',
      yamjs_revision: '<not configured>',
      environment: '<not configured>',
      ...(userId && { UserId: userId }),
      ...(networkId && { NetworkId: networkId }),
    };
  }

  const { yammerAppClientId, telemetryClientId, appInstanceId, loadedAt, gitRevision } = clientConfig;

  return {
    ClientId: yammerAppClientId,
    first_party_client: telemetryClientId,
    client_load_id: appInstanceId,
    client_load_time: loadedAt.toString(),
    yamjs_revision: gitRevision,
    environment: hostingConfig.hostingEnvironment,
    ...(userId && { UserId: userId }),
    ...(networkId && { NetworkId: networkId }),
  };
};
